import { CalendarClock, CheckCircle2, CircleSlash, Sparkles } from "lucide-react";
import { Badge } from "./ui/Badge";

export function StatusBadge({ status }: { status: "open" | "accepted" | "cancelled" | "completed" }) {
  switch (status) {
    case "open":
      return (
        <Badge tone="warning">
          <CalendarClock className="h-3.5 w-3.5 mr-1 -ml-0.5" /> Needs coverage
        </Badge>
      );
    case "accepted":
      return (
        <Badge tone="success">
          <CheckCircle2 className="h-3.5 w-3.5 mr-1 -ml-0.5" /> Covered
        </Badge>
      );
    case "cancelled":
      return (
        <Badge tone="neutral">
          <CircleSlash className="h-3.5 w-3.5 mr-1 -ml-0.5" /> Cancelled
        </Badge>
      );
    case "completed":
      return (
        <Badge tone="info">
          <Sparkles className="h-3.5 w-3.5 mr-1 -ml-0.5" /> Completed
        </Badge>
      );
  }
}
